export const ButtonsTypes = {
  ADD: 'add',
  PARAMS: 'params',
  QUERY: 'saveQuery',
  EDIT_QUERY: 'editQuery',
  DELETE_QUERY: 'deleteQuery',
  STATUS: 'status',
  SAVE: 'save',
  CANCEL: 'cancel',
  DOWNLOAD: 'download',
  SAVE_AND_CONTINUE: 'saveAndContinue',
  EDIT_USER: 'editUser',
  SAVE_CANCEL: 'saveCancel',
  ADD_BASE_PLAN: 'addBasePlan',
};
